export default {
	fieldSelectorAttribute: 'field',
	fieldsSelectorAttribute: 'fields',
	groupAttribute: 'fieldsGroup',
	nameAttribute: 'field',
	typeAttribute: 'fieldType',
	errorsSelectorAttribute: 'fieldErrors'
};
